import Grid from "@mui/material/Grid";
import SuiBox from "components/SuiBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import LeadValidationCard from "./components/LeadValidationCard";
import React from "react";

function leadValidation() {
  if(localStorage != null) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox py={3}>
        <SuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <LeadValidationCard/>
            </Grid>
          </Grid>
        </SuiBox>
      </SuiBox>
        <Footer />
      </DashboardLayout>
    );
  }
}

export default leadValidation;